import { useAppSelector } from "~/hooks";
import { AppDiagram } from "../components/AppDiagram";
import { GeneratingSpinner } from "../components/GeneratingSpinner";
import { SectionErrorBoundary } from "../components/SectionErrorBoundary";
import { SectionWrapper } from "../components/SectionWrapper";
import { StaleWarning } from "../components/StaleWarning";
import type { SectionStatus } from "../hooks/usePageViewData";
import styles from "./AppDesignSection.module.scss";

type AppDesignSectionProps = {
  number: number;
  status: SectionStatus;
  detailPath: string;
  onGenerate: (documentType: string) => void;
  canRegenerate: boolean;
};

export const AppDesignSection = ({
  number,
  status,
  detailPath,
  onGenerate,
  canRegenerate,
}: AppDesignSectionProps) => {
  const { appData, connectorData, isMarkdown } = useAppSelector((s) => s.appDesign);

  const renderContent = () => {
    if (isMarkdown) {
      return (
        <div className={styles["fallback"]}>
          図形式で表示できません。詳細ページで確認してください →
        </div>
      );
    }

    if (appData.length === 0) {
      return <div className={styles["fallback"]}>アプリ設計データがありません</div>;
    }

    return <AppDiagram apps={appData} connectors={connectorData} />;
  };

  if (status === "generating") {
    return (
      <SectionWrapper
        number={number}
        title="作成するアプリ（アプリ設計書）"
        status={status}
        detailPath={detailPath}
        onGenerate={() => onGenerate("app-design")}
        disableGenerate={!canRegenerate}
      >
        <GeneratingSpinner />
      </SectionWrapper>
    );
  }

  if (status === "stale") {
    return (
      <SectionWrapper
        number={number}
        title="作成するアプリ（アプリ設計書）"
        status={status}
        detailPath={detailPath}
        onGenerate={() => onGenerate("app-design")}
        disableGenerate={!canRegenerate}
      >
        <SectionErrorBoundary sectionName="作成するアプリ（アプリ設計書）" detailPath={detailPath}>
          {renderContent()}
        </SectionErrorBoundary>
        <StaleWarning />
      </SectionWrapper>
    );
  }

  return (
    <SectionWrapper
      number={number}
      title="作成するアプリ（アプリ設計書）"
      status={status}
      detailPath={detailPath}
      onGenerate={() => onGenerate("app-design")}
      disableGenerate={!canRegenerate}
    >
      <SectionErrorBoundary sectionName="作成するアプリ（アプリ設計書）" detailPath={detailPath}>
        {renderContent()}
      </SectionErrorBoundary>
    </SectionWrapper>
  );
};
